import { isOneOf } from "./isOneOf";

const noWebViewErrors = [
    "Error: WebView2bridgeNotInitialized:NoWebView. Source: nativeRunBeforeStart.ts",
];

export function isNoWebViewError(message: string | undefined): boolean {
    return isOneOf(noWebViewErrors, message);
}
